import { Toaster as Sonner } from "sonner"

export function Toaster() {
  return (
    <Sonner
      richColors
      closeButton
      position="top-right"
      toastOptions={{
        className: "border border-border bg-popover text-popover-foreground",
      }}
    />
  )
}
